<template>
    <div>
      <q-dialog v-model="show" @hide="onClose" maximized>
        <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
          <q-header class="bg-primary">
            <q-toolbar>
              <q-toolbar-title>
                <translate>{{ label }}</translate>
              </q-toolbar-title>
              <q-btn v-close-popup flat round dense icon="close" @click="onClose" />
            </q-toolbar>
          </q-header>
          <q-page-container>
            <crud-layout-search
              v-if="!isShowClient && !isShowGenerator && !isShowCarrier"
              ref="crudLayoutSearch"
              :interface="this.interface"
              :id="person"
              clean-layout
              :params="{ person: person }"
              @action-button="showForm"
              :load="load()"
            />
            <client-page
              v-if="isShowClient"
              :id="client"
              :name="name"
            />
            <GeneratorPage
              v-if="isShowGenerator"
              :id= "generator"
              :forms ="generatorForm"
              @action-button="editGenerator"
            />
            <modal
              v-if="generatorDetail.show"
              ref="generator-detail"
              :show="generatorDetail.show"
              :detail="true"
              v-bind="generatorDetail"
              @input="(show) => (generatorDetail.show = show)"
              @action-button="openDetailDocumentModal"
              :label="this.$gettext('GENERATOR')"
            />
            <CarrierPage
              v-if="isShowCarrier"
              :id="carrier"
              :forms ="carrierForm"
              @action-button="editCarrier"
            />
          </q-page-container>
        </q-layout>
      </q-dialog>
    </div>
  </template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { repository } from 'jtech'
import ClientPage from '../../client/ClientPage.vue'
import GeneratorPage from '../../generator/generator/GeneratorPage.vue'
import CarrierPage from '../../carrier/carrier/CarrierPage.vue'

const { CrudLayoutSearch, pageTable, modal } = JtCrud
  @Component({
    mixins: [pageTable],
    name: 'CrudLayoutModalPage',
    components: { CrudLayoutSearch, pageTable, ClientPage, GeneratorPage, CarrierPage, modal },
    props: {
      label: String,
      interface: {
        type: String,
        required: true
      },
      show: {
        type: Boolean,
        default: false
      },
      person: {
        type: Number,
        required: true
      }
    }
  })

class PersonComponentModal extends Vue {
    isShowClient = false;
    isShowGenerator = false;
    isShowGeneratorDetail = false;
    isShowCarrier = false;
    generator = null;
    client = null;
    carrier = null;
    generatorForm = null;
    carrierForm = null;
    name = null
    isAddNewButtonClicked = false;
    generatorDetail = {
      show: false
    }

    get page () {
      return ClientPage
    }

    load () {
      if (this.$refs.crudLayoutSearch) {
        this.$refs.crudLayoutSearch.onButton('icAlterar', this.showForm)
        this.$refs.crudLayoutSearch.onButton('btNovo', this.onAddNewButton)
      } else {
        setTimeout(() => {
          this.load()
        }, 100)
      }
    }

    showClientForm (params) {
      this.client = params.id
      this.name = params.person_name || params.client_person_legalEntity_fantasyName
      this.isShowClient = true
    }

    onClose () {
      this.$emit('on-close', {})
      this.isShowClient = false
      this.isShowGenerator = false
      this.isShowCarrier = false
    }

    async showGeneratorForm (params) {
      this.generator = params.id
      const action = this.isAddNewButtonClicked ? 'generator.gravar' : 'generator.alterarPersonalizado'
      this.generatorForm = await repository.resolve(action, params)
      if (this.generatorForm) {
        this.isShowGenerator = true
      }
      this.isAddNewButtonClicked = false
    }

    async showGeneratorFormDetail (params) {
      const forms = await repository.resolve('generator.detalhar', { id: params.id })
      this.generatorDetail = {
        show: true,
        params: params,
        forms: forms
      }
    }

    async showCarrierForm (params) {
      this.carrier = params.id
      const action = this.isAddNewButtonClicked ? 'carrier.gravar' : 'carrier.alterarPersonalizado'
      this.carrierForm = await repository.resolve(action, params)
      if (this.carrierForm) {
        this.isShowCarrier = true
      }
      this.isAddNewButtonClicked = false
    }

    async showForm ({ button, params, page }) {
      if (this.interface.indexOf('client') >= 0) {
        this.showClientForm(params)
      } else if (this.interface.indexOf('generator') >= 0) {
        await this.showGeneratorForm(params)
      } else if (this.interface.indexOf('carrier') >= 0) {
        await this.showCarrierForm(params)
      }
    }

    async editGenerator (button, params, page) {
      if (button.name != 'icAlterarComposicaoClient') {
        if (button.action !== 'generator.gravar') {
          await repository.update(button.action, {
            id: this.generator,
            ...params
          })
        } else {
          await repository.create(button.action, {
            id: this.generator,
            ...params
          })
        }
        this.isShowGenerator = false
      } else {
        this.isShowGenerator = false
        this.showClientForm(params)
      }
    }

    async editCarrier (button, params, page) {
      if (button.name === 'icAlterarComposicaoGenerator') {
        this.isShowCarrier = false
        await this.showGeneratorForm(params)
      } else if (button.name === 'icDetalharComposicaoGenerator') {
        await this.showGeneratorFormDetail(params)
      } else {
        if (button.action !== 'carrier.gravar') {
          await repository.update(button.action, {
            id: this.carrier,
            ...params
          })
        } else {
          await repository.create(button.action, {
            id: this.carrier,
            ...params
          })
        }
        this.isShowCarrier = false
      }
    }

    onAddNewButton () {
      this.isAddNewButtonClicked = true
      this.showForm({ button: { action: 'btNovo' }, params: {}, page: null })
    }
  }
export default PersonComponentModal
</script>
  <style lang="stylus" scoped>
    .q-page-container {
      padding-top: 70px !important;
    }

  </style>
